import fetch from '../../../../core/fetch';
import showToaster from '../../../../helpers/toasterMessages/showToaster';
import { demoRestriction } from '../../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {

  const isRestrict = await dispatch(demoRestriction({}));
  if (isRestrict) return;

  const query = `
  mutation (
    $workTitleHeading: String,
    $peaceTitle1: String,
    $peaceTitle2: String,
    $peaceContent1: String,
    $peaceContent2: String,
    $workImage4: String,
    $dynamicWhyHostInfoBlock: String,
) {
  updateWhyHostPage (
    workTitleHeading: $workTitleHeading,
    peaceTitle1: $peaceTitle1,
    peaceTitle2: $peaceTitle2,
    peaceContent1: $peaceContent1,
    peaceContent2: $peaceContent2,
    workImage4: $workImage4,
    dynamicWhyHostInfoBlock: $dynamicWhyHostInfoBlock,
  ) {
      status
  }
}

  `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables: {
        workTitleHeading: values.dynamicWhyHostInfoBlock[0].workTitleHeading,
        peaceTitle1: values.dynamicWhyHostInfoBlock[0].peaceTitle1,
        peaceTitle2: values.dynamicWhyHostInfoBlock[0].peaceTitle2,
        peaceContent1: values.dynamicWhyHostInfoBlock[0].peaceContent1,
        peaceContent2: values.dynamicWhyHostInfoBlock[0].peaceContent2,
        workImage4: values.workImage4,
        dynamicWhyHostInfoBlock: JSON.stringify(values.dynamicWhyHostInfoBlock),
      }
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data.updateWhyHostPage.status === "success") {
    showToaster({ messageId: 'updateWhyHostPage', toasterType: 'success' })
  } else {
    showToaster({ messageId: 'updateWhyHostPageFailed', toasterType: 'error' })
  }

}

export default submit;
